export default __webpack_public_path__ + "static/media/sort-by.ccddfb3d.svg";